import angular from 'angular';
import GiftcardController from "./form.controller";

let giftcard = angular
    .module('giftcard', [])
    .controller('GiftcardController', GiftcardController);

export default giftcard;

